import PropTypes from "prop-types";
import React, { Component } from "react";
import { compose, withState } from "recompose";
import { Button } from "cxa-components";
import FloatingBox from "./FloatingBox";

class ToggleButton extends Component {
  render() {
    const {
      className,
      label,
      children,
      icon: Icon,
      isOpen,
      toggleIsOpen,
    } = this.props;

    return (
      <span className="apl-floating-box__parent">
        <Button
          className={`apl-toggle-button ${!!className && className}`}
          onClick={() => toggleIsOpen(!isOpen)}
          type="button"
        >
          {Icon && <Icon />}
          <span>
            {label}
          </span>
        </Button>
        {isOpen &&
          <FloatingBox>
            {children}
          </FloatingBox>}
      </span>
    );
  }
}

ToggleButton.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.object,
  icon: PropTypes.func,
  isOpen: PropTypes.bool,
  toggleIsOpen: PropTypes.func,
};

export default compose(withState("isOpen", "toggleIsOpen", false))(
  ToggleButton
);



// WEBPACK FOOTER //
// ./components/common/ToggleButton.js